import { Colors, Icon, Text } from '@amelio/ui-library';

import type { ReactNode } from 'react';

export type TipNumberColor = 'orange' | 'teal' | 'purple';

const NUMBER_COLOR_CLASSES: Record<TipNumberColor, string> = {
    orange: 'bg-orange-400',
    teal: 'bg-teal-500',
    purple: 'bg-purple-500',
};

interface TipSectionShellProps {
    title: string;
    number: number;
    numberColor: TipNumberColor;
    isOpen: boolean;
    onToggle: () => void;
    children: ReactNode;
}

export const TipSectionShell = ({
    title,
    number,
    numberColor,
    isOpen,
    onToggle,
    children,
}: TipSectionShellProps) => {
    return (
        <div className={'overflow-hidden rounded-xl bg-white'}>
            <button
                type={'button'}
                onClick={onToggle}
                className={
                    'flex w-full cursor-pointer items-center justify-between !px-4 !py-4 md:!px-7 md:!py-5'
                }
                data-testid={`tip-section-toggle-${title}`}
            >
                <div className={'flex items-center gap-3'}>
                    <span
                        className={`flex !h-11 !w-11 shrink-0 items-center justify-center rounded-full !text-lg font-semibold text-white shadow-lg ${NUMBER_COLOR_CLASSES[numberColor]}`}
                    >
                        {number}
                    </span>

                    <Text
                        size={'default'}
                        weight={'semibold'}
                        color={Colors.BASE_600}
                        className={'!text-lg'}
                    >
                        {title}
                    </Text>
                </div>

                <Icon
                    name={'arrow-arrow-down'}
                    size={'sm'}
                    color={Colors.BASE_400}
                    rotate={isOpen ? 180 : 0}
                />
            </button>

            {isOpen && <div className={'!px-4 !pb-4 md:!px-7 md:!pb-5'}>{children}</div>}
        </div>
    );
};

export default TipSectionShell;
